export enum AccessorTypesEnum {
  ChannelMember = 'ChannelMember',
  Label = 'Label',
}
